import React, { useEffect, useMemo, useRef, useState } from 'react'
import styles from './ApproachMobile.module.css'
export function useOnScreen(ref) {

  const [isIntersecting, setIntersecting] = useState(false)

  const observer = useMemo(() => new IntersectionObserver(
    ([entry]) => setIntersecting(entry.isIntersecting)
  ), [ref])


  useEffect(() => {
    observer.observe(ref.current)
    return () => observer.disconnect()
  }, [])
  // //console.log(isInters ecting);
  return isIntersecting
}
function ApproachesMobile() {
  const ref1 = useRef()
  const isVisible2 = useOnScreen(ref1)
  return (
    <div>
      <div ref={ref1} className={`${styles.ServiceRight} ${styles.showMobileView}`}>
        <div className={styles.circleContainer}>
          <div className={styles.mainCircle}>
            <p style={{ color: "#fff" }}>PROBLEM</p>
            <div className={styles.arrowIcon}>
              <p className={styles.arrow1}></p>
              <p className={styles.arrow2}></p>
            </div>
            <div className={styles.arrowIcon1}>
              <p className={styles.arrow3}></p>
              <p className={styles.arrow4}></p>
            </div>
            <div className={styles.arrowIcon2}>
              <p className={styles.arrow5}></p>
              <p className={styles.arrow6}></p>
            </div>
          </div>

        </div>
        <div

          // data-aos="fade-right?"
          className={`${isVisible2 ? styles.c1Mobile : styles.c1MobileShow}`}>
          <p style={{ color: "#fff" }}>International Network</p>
        </div>
        <div

          //  data-aos="fade-left" 
          className={`${isVisible2 ? styles.c2Mobile : styles.c2MobileShow}`}>
          <p style={{ color: "#fff" }}>Business Professional</p>
        </div>
        <div

          //  data-aos="fade-down" 
          className={`${isVisible2 ? styles.c3Mobile : styles.c3MobileShow}`}>
          <p style={{ color: "#fff" }}>IT <br /> Professional</p>
        </div>
      </div>
    </div>
  )
}

export default ApproachesMobile